import { styled } from 'styled-components'
import { Divider as MUIDivider } from '@mui/material'

export const Divider = styled(MUIDivider)`
  background-color: ${({ theme }) => theme.colors.secondaryDark};
  width: 2px;
  border-radius: 2px;
`
